import React from 'react'
import { Button, Divider, Form, Input, message, Select } from 'antd'
import { FormComponent } from '../../../../../BaseComponent'
import { QrCodeContextData } from '../../../../../../context/QrCodeContext'
import IBranch from '../../../../../../interfaces/IBranch'
import IQrCode from '../../../../../../interfaces/IQrCode'
import { QrCodeCreateRequest, QrCodeUpdateRequest } from '../../../../../../services/api/interfaces/ApiRequest'

export type RegisterQrCodeProps = {
  context: QrCodeContextData,
  data?: IQrCode,

  shelterBranches: IBranch[]

  onFinished: (err?: any) => void
}

export default class RegisterQrCode extends FormComponent<RegisterQrCodeProps> {

  state = {
    saving: false
  }

  async componentDidMount() {
    const { context } = this.props

    if (!context.qrCodeTypes) {
      await context.requestQrCodeTypeList({
        options: {
          _force_ids: true,
          limit:9999
        }
      })
    }
  }

  private handleSave = async (values: any) => {
    const { context, data, onFinished } = this.props

    this.setState({
      saving: true
    }, async () => {
      try {
        if (!data) {
          const payload: QrCodeCreateRequest = {
            qr_code: values
          }
          await context.requestQrCodeCreate(payload)
        } else {
          const payload: QrCodeUpdateRequest = {
            qr_code: {
              uuid: data.uuid,
              title: values.title,
              description: values.description
            }
          }
          await context.requestQrCodeUpdate(payload)
        }

        message.success('QR Code save successfully!')

        onFinished()
      } catch (error) {
        message.error(`Failed to save new QR Code. Reason: ${error}`)
        onFinished(error)
      } finally {
        this.setState({
          saving: false
        })
      }
    })
  }

  render() {
    const { shelterBranches, data, context } = this.props
    const { saving } = this.state

    let values: any = {}
    if (data) {
      values = {
        ...data,
        branch_uuid: data.branch?.uuid
      }
    }

    return (
      <Form
        name="organization_qr_code"
        initialValues={values}
        layout="vertical"
        ref={ref => {
          if (!this.formRef) {
            this.formRef = ref
            this.forceUpdate()
          }
        }}
        onFinish={this.handleSave}
      >
        <Form.Item
          label="Title"
          name="title"
          rules={[
            {
              required: true,
              message: 'Title is required'
            }
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Type"
          name="type_key"
          rules={[
            {
              required: true,
              message: 'Type is required'
            }
          ]}
        >
          <Select
            disabled={!!data}
            loading={context.fetching || false}
            options={context.qrCodeTypes?.map(v => {
              return {
                label: v.name,
                value: v.key
              }
            })}
          />
        </Form.Item>

        <Form.Item
          label="Location"
          name="branch_uuid"
          rules={[
            {
              required: true,
              message: 'Location is required'
            }
          ]}
        >
          <Select
            disabled={!!data}
            options={shelterBranches.map(v => {
              return {
                label: v.name,
                value: v.uuid
              }
            })}
          />
        </Form.Item>

        <Form.Item
          label="Description"
          name="description"
        >
          <Input.TextArea rows={2} />
        </Form.Item>

        <Divider />

        <Button
          type="primary"
          htmlType="submit"
          loading={saving}
          block
        >
          Save
        </Button>
      </Form>
    )
  }
}
